import './MovementApp.css';
import Background from './Components/background';
import Logo from './Components/logo';
import Box from './Components/box';
import ButtonBar from './Components/buttonBar';
import blood from './Assets/blood.png'
import { Outlet } from 'react-router-dom';
import React from 'react';


function App({mainBoxHeight, mainBoxWidth, borderWidth, windowX, windowY}) {

  React.useEffect(() => {
    let link = document.querySelector("link[rel~='icon']");
    if (!link) {
      link = document.createElement('link');
      link.rel = 'icon';
      document.getElementsByTagName('head')[0].appendChild(link);
    }
    link.href = '/favicon2.ico';
  }, []);


  return (
    <div className="App">
      <div style={{position: 'absolute', overflow:'hidden', zIndex: "-1"}}>
        <Background screenX={Math.max(windowX,mainBoxWidth+borderWidth)} screenY={mainBoxHeight+260}/>
      </div>
      <img src={blood} alt={"blood"} style={{display:"block", marginLeft:"auto", marginRight:"auto", opacity:0.6, maxWidth: mainBoxWidth}}/>
      <div>
        <Logo/>
        <Box height={mainBoxHeight} width={mainBoxWidth} corner={50} style={{position:"absolute", top:220, left:Math.max(0,(windowX-mainBoxWidth)/2), margin:"0 auto"}}>
        
          <ButtonBar width={mainBoxWidth-60} height={80} cornerSize={26} buttons={[
            {text: "About", href:"/"},
            {text: "Download", href:"/download", minWidth:190},
            {text: "Chat", href:"/chat"},
            {text: "FAQ", href:"/faq"},
            {text: "History", href:"/history", minWidth:180}
          ]} />
          

          <Outlet />
        </Box>
      </div>
 

        


      
    </div>
  );
}

export default App;
